(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["look-card-carousel"] && !Shopify.designMode) return;
  try {
    
  class KitLookCardCarousel extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      this.sectionId = this.querySelector('[data-section-id]')?.dataset.sectionId;
      this.initLookSetDrawers();

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });

        this.initPopoverBehavior();
      }

      // Clicking a colour swatch inside a popover should preview that product in the popover
      // (image / title / price) and retarget the "Shop Now" button — not navigate away.
      this.addEventListener('click', (event) => {
        const swatchAnchor = event.target.closest(
          '.look-card-carousel__popover-swatches .productSwatch a[data-related-product-id]'
        );
        if (swatchAnchor) {
          event.preventDefault();
          this.selectPopoverSwatch(swatchAnchor);
          return;
        }

        // Tapping the product image, the title/price content, or the close
        // wrapper (but not the close button itself) navigates to the product
        // page of the currently-previewed product.
        if (event.target.closest('[data-popover-close]')) return;
        const navZone = event.target.closest(
          '.shoppable-hero__popover-image, .shoppable-hero__popover-content, .shoppable-hero__popover-close'
        );
        if (!navZone) return;
        const body = navZone.closest('.shoppable-hero__popover-body');
        const url = body?.getAttribute('data-product-url');
        if (url) window.location.href = url;
      }, { signal });

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
          this.initLookSetDrawers();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('.look-card-carousel__hotspot-trigger');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initPopoverBehavior() {
      const signal = this.abortController.signal;
      const CLOSE_DELAY = 220;
      const hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)');
      // Don't auto-close on hover-out in the theme editor, so a merchant can
      // edit an open card without it closing when their cursor drifts away.
      const hoverClosesEnabled = () => hoverCapable.matches && !window.Shopify?.designMode;

      // Desktop: keep the card open while the cursor is over the hotspot or the
      // popover, and close it shortly after the cursor leaves both. The grace
      // delay lets the pointer cross the small gap between trigger and popover.
      this.querySelectorAll('.look-card-carousel__hotspot').forEach((hotspot) => {
        const trigger = hotspot.querySelector('.look-card-carousel__hotspot-trigger[popovertarget]');
        const popover = hotspot.querySelector('kit-popover');
        if (!trigger || !popover) return;

        let closeTimer = null;
        const clearCloseTimer = () => {
          if (closeTimer) {
            clearTimeout(closeTimer);
            closeTimer = null;
          }
        };
        const scheduleClose = () => {
          clearCloseTimer();
          closeTimer = setTimeout(() => {
            closeTimer = null;
            if (popover.matches(':popover-open')) popover.hidePopover();
          }, CLOSE_DELAY);
        };

        [trigger, popover].forEach((el) => {
          el.addEventListener('mouseenter', () => {
            if (hoverClosesEnabled()) clearCloseTimer();
          }, { signal });
          el.addEventListener('mouseleave', () => {
            if (hoverClosesEnabled() && popover.matches(':popover-open')) scheduleClose();
          }, { signal });
        });

        popover.addEventListener('toggle', (event) => {
          if (event.newState !== 'open') clearCloseTimer();
        }, { signal });
      });

      // Mobile / touch (and any click outside): tap outside an open card closes it.
      document.addEventListener('pointerdown', (event) => {
        const openPopovers = this.querySelectorAll('kit-popover:popover-open');
        if (!openPopovers.length) return;

        openPopovers.forEach((popover) => {
          if (popover.contains(event.target)) return;
          const hotspot = popover.closest('.look-card-carousel__hotspot');
          if (hotspot && hotspot.contains(event.target)) return;
          popover.hidePopover();
        });
      }, { signal });
    }

    selectPopoverSwatch(anchor) {
      const popover = anchor.closest('kit-popover');
      const container = anchor.closest('.look-card-carousel__popover-swatches');
      if (!popover || !container) return;

      // Move the active state to the clicked swatch.
      container.querySelectorAll('.productSwatch, .productSwatch a').forEach((el) => {
        el.classList.remove('active');
      });
      anchor.classList.add('active');
      anchor.closest('.productSwatch')?.classList.add('active');

      const data = {
        id: anchor.getAttribute('data-related-product-id') || '',
        url: anchor.getAttribute('data-swatch-url') || anchor.getAttribute('href') || '',
        title: anchor.getAttribute('data-product-title') || anchor.getAttribute('title') || '',
        price: parseInt(anchor.getAttribute('data-product-price') || '0', 10) || 0,
        comparePrice: parseInt(anchor.getAttribute('data-product-compare-price') || '0', 10) || 0,
        priceVaries: (anchor.getAttribute('data-product-price-varies') || '').toLowerCase() === 'true',
        image: anchor.getAttribute('data-swatch-img-first') || ''
      };

      const bodyEl = popover.querySelector('.shoppable-hero__popover-body');
      if (bodyEl && data.url) bodyEl.setAttribute('data-product-url', data.url);

      const imageEl = popover.querySelector('.shoppable-hero__popover-image');
      if (imageEl && data.image) {
        imageEl.style.setProperty('--popover-bg', `url('${data.image}')`);
      }

      const titleEl = popover.querySelector('.shoppable-hero__popover-title');
      if (titleEl && data.title) titleEl.textContent = data.title;

      const priceEl = popover.querySelector('.grid-product__price');
      if (priceEl) priceEl.innerHTML = this.formatPopoverPriceHtml(data);

      // Retarget "Shop Now" so it opens the selected colour's quick-add modal.
      const shopNow = popover.querySelector('.look-card-carousel__popover-link[data-quick-add]');
      if (shopNow) {
        const handle = this.handleFromProductUrl(data.url);
        if (handle) shopNow.setAttribute('data-product-handle', handle);
        if (data.id) shopNow.setAttribute('data-product-id', data.id);
      }
    }

    handleFromProductUrl(url) {
      if (!url) return '';
      const clean = url.split('?')[0].split('#')[0].replace(/\/+$/, '');
      const match = clean.match(/\/products\/([^/]+)$/);
      return match ? match[1] : '';
    }

    formatPopoverPriceHtml(data) {
      const formatMoney = (cents) => {
        if (window.theme?.Currency?.formatMoney) {
          return window.theme.Currency.formatMoney(cents, window.theme.settings?.moneyFormat);
        }
        return '$' + (Math.round(cents) / 100).toFixed(2);
      };

      let html = '';
      if (data.comparePrice > data.price) {
        html += `<span class="grid-product__price--original">${formatMoney(data.comparePrice)}</span>`;
      }

      let main = formatMoney(data.price);
      if (data.priceVaries && window.theme?.strings?.productFrom) {
        main = `${window.theme.strings.productFrom}${main}`;
      }
      html += `<div>${main}</div>`;
      return html;
    }

    initLookSetDrawers() {
      const signal = this.abortController.signal;
      const stringsNode = this.querySelector('[data-look-set-i18n]');
      let strings = {
        soldOut: 'Sold out',
        errorIncomplete: 'Select all options before adding the set to your cart.',
        errorAddFailed: 'Unable to add this set to your cart. Please try again.',
        minItems: 'Your set needs at least one item.',
        sizeGuide: 'Size guide',
        useCodePrefix: 'Use code:',
        discountBadgeHtml: '[amount] Off'
      };

      if (stringsNode) {
        try {
          strings = { ...strings, ...JSON.parse(stringsNode.textContent || '{}') };
        } catch (err) {
          console.warn('Unable to parse look set i18n strings', err);
        }
      }

      const parseJsonAttr = (el, name, fallback) => {
        try {
          const raw = el?.getAttribute(name);
          return raw ? JSON.parse(raw) : fallback;
        } catch (err) {
          return fallback;
        }
      };

      const variantOptions = (variant) => {
        if (Array.isArray(variant?.options)) return variant.options;
        return [variant?.option1, variant?.option2, variant?.option3].filter(Boolean);
      };

      const variantMatchesSelectedOptions = (variant, selectedOptions, skipIndex) => {
        const options = variantOptions(variant);
        return selectedOptions.every((value, index) => {
          if (index === skipIndex || value == null || value === '') return true;
          return options[index] === value;
        });
      };

      const displayOptionText = (value, optionName) => {
        if (!String(optionName || '').trim().toLowerCase().includes('size')) return value;

        const normalized = String(value || '').trim().toLowerCase();
        const labels = {
          xsmall: 'XS',
          small: 'S',
          medium: 'M',
          large: 'L',
          'extra large': 'XL',
          'x-large': 'XL',
          xl: 'XL',
          xlarge: 'XL',
          'xx-large': 'XXL',
          xxl: 'XXL',
          xxlarge: 'XXL'
        };

        return labels[normalized] || value;
      };

      const findVariantForSelectedOptions = (item, selectedOptions) => {
        const variants = parseJsonAttr(item, 'data-product-variants', []);
        const matching = variants.filter(variant => variantMatchesSelectedOptions(variant, selectedOptions));
        return matching.find(variant => variant.available) || matching[0] || null;
      };

      const splitStyleLabel = (title) => {
        const pieces = String(title || '').split('-').map(part => part.trim()).filter(Boolean);
        if (pieces.length < 2) return String(title || '');
        return pieces[pieces.length - 1];
      };

      const splitStyleTitle = (title) => {
        const pieces = String(title || '').split('-').map(part => part.trim()).filter(Boolean);
        return pieces[0] || String(title || '');
      };

      const buildVariantLabel = (fabricLabel, colorLabel) => {
        if (fabricLabel && colorLabel) return `${fabricLabel} / ${colorLabel}`;
        return fabricLabel || colorLabel || '';
      };

      const escapeHtml = (value) => {
        return String(value || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      };

      const computeDiscountBadge = (price, comparePrice) => {
        const p = Number.parseInt(String(price ?? '0'), 10) || 0;
        const c = Number.parseInt(String(comparePrice ?? '0'), 10) || 0;
        if (!c || c <= p) return '';

        let amount = '';
        if (theme.settings?.saveType === 'dollar') {
          amount = formatMoney(c - p);
        } else {
          amount = `${Math.round(((c - p) * 100) / c)}%`;
        }

        return (strings.discountBadgeHtml || '[amount] Off').replace('[amount]', amount);
      };

      const updateItemVariantLabel = (item, fabricLabel, colorLabel) => {
        const labelEl = item.querySelector('[data-look-set-variant-label]');
        if (!labelEl) return;

        const label = buildVariantLabel(fabricLabel, colorLabel);
        labelEl.textContent = label;
        labelEl.hidden = !label;
      };

      const updateItemPromo = (item, discountBadge, promoCode) => {
        const promoEl = item.querySelector('[data-look-set-promo]');
        const badgeEl = item.querySelector('[data-look-set-promo-badge]');
        const codeEl = item.querySelector('[data-look-set-promo-code]');
        const hasBadge = !!discountBadge;
        const hasCode = !!promoCode;

        if (promoEl) promoEl.hidden = !(hasBadge || hasCode);

        if (badgeEl) {
          if (hasBadge) {
            badgeEl.hidden = false;
            badgeEl.innerHTML = `<span class="grid-product__badge">${escapeHtml(discountBadge)}</span>`;
          } else {
            badgeEl.hidden = true;
            badgeEl.innerHTML = '';
          }
        }

        if (codeEl) {
          if (hasCode) {
            codeEl.hidden = false;
            codeEl.textContent = `${strings.useCodePrefix} ${promoCode}`;
          } else {
            codeEl.hidden = true;
            codeEl.textContent = '';
          }
        }

        if (hasBadge) {
          item.setAttribute('data-discount-badge', discountBadge);
        } else {
          item.removeAttribute('data-discount-badge');
        }
      };

      const updateItemProductLinks = (item, url) => {
        if (!item || !url) return;

        item.setAttribute('data-product-url', url);
        item.querySelectorAll('[data-look-set-product-link]').forEach(link => {
          link.setAttribute('href', url);
        });
      };

      const parseSwatchProductData = (source) => {
        if (!source) return null;
        const title = source.getAttribute('data-product-title') || source.getAttribute('title') || '';
        const url = source.getAttribute('data-product-url') || source.getAttribute('href') || '';
        return {
          id: source.getAttribute('data-related-product-id') || source.getAttribute('data-product-id') || '',
          title,
          url,
          styleTitle: source.getAttribute('data-product-style-title') || splitStyleTitle(title),
          price: Number.parseInt(source.getAttribute('data-product-price') || '0', 10) || 0,
          comparePrice: Number.parseInt(source.getAttribute('data-product-compare-price') || '0', 10) || 0,
          priceVaries: (source.getAttribute('data-product-price-varies') || '').toLowerCase() === 'true',
          imageFirst: source.getAttribute('data-swatch-img-first') || '',
          options: parseJsonAttr(source, 'data-product-options', []),
          variants: parseJsonAttr(source, 'data-product-variants', []),
          hoverOptionIndexes: parseJsonAttr(source, 'data-hover-option-indexes', [])
            .map(index => Number.parseInt(index, 10))
            .filter(index => Number.isFinite(index) && index >= 0),
          promoCode: source.getAttribute('data-promo-code') || '',
          fabricLabel: source.getAttribute('data-fabric-label') || ''
        };
      };

      const formatMoney = (cents) => {
        const moneyFormat = theme.settings?.moneyWithCurrencyFormat || theme.settings?.moneyFormat;
        if (window.theme?.Currency?.formatMoney) {
          return theme.Currency.formatMoney(cents || 0, moneyFormat);
        }
        return ((cents || 0) / 100).toFixed(2);
      };

      const getItemQuantity = (item) => {
        const input = item.querySelector('.js-qty__num');
        const qty = Number.parseInt(input?.value || '1', 10);
        return Number.isFinite(qty) && qty > 0 ? qty : 1;
      };

      const getItemMedia = (item) => {
        const script = item.querySelector('[data-look-set-media]');
        if (!script) return [];
        try {
          const parsed = JSON.parse(script.textContent || '[]');
          return Array.isArray(parsed) ? parsed : [];
        } catch (err) {
          return [];
        }
      };

      const setItemImage = (item, src, alt) => {
        const image = item.querySelector('[data-look-set-image]');
        if (!image || !src) return;
        image.src = src;
        if (alt) image.alt = alt;
        item.dataset.lookSetImageIndex = '0';
      };

      const updateItemImageNav = (item) => {
        const media = getItemMedia(item);
        const prev = item.querySelector('[data-look-set-image-prev]');
        const next = item.querySelector('[data-look-set-image-next]');
        const showNav = media.length > 1;
        if (prev) prev.hidden = !showNav;
        if (next) next.hidden = !showNav;
      };

      const shiftItemImage = (item, direction) => {
        const media = getItemMedia(item);
        if (media.length < 2) return;
        const currentIndex = Number.parseInt(item.dataset.lookSetImageIndex || '0', 10) || 0;
        const nextIndex = (currentIndex + direction + media.length) % media.length;
        const nextMedia = media[nextIndex];
        setItemImage(item, nextMedia.src, nextMedia.alt);
        item.dataset.lookSetImageIndex = String(nextIndex);
      };

      const ensureSelectedOptions = (item, selectedOptions) => {
        const variants = parseJsonAttr(item, 'data-product-variants', []);
        const indexes = parseJsonAttr(item, 'data-hover-option-indexes', [])
          .map(index => Number.parseInt(index, 10))
          .filter(index => Number.isFinite(index) && index >= 0);

        indexes.forEach(index => {
          const currentValue = selectedOptions[index];
          const currentAvailable = currentValue && variants.some(variant => {
            return variantOptions(variant)[index] === currentValue
              && variant.available
              && variantMatchesSelectedOptions(variant, selectedOptions, index);
          });

          if (currentAvailable) return;

          const seen = new Set();
          for (const variant of variants) {
            const optionValue = variantOptions(variant)[index];
            if (!optionValue || seen.has(optionValue)) continue;
            seen.add(optionValue);

            const valueVariants = variants.filter(candidate => variantOptions(candidate)[index] === optionValue);
            const availableForSelection = valueVariants.some(candidate => {
              return candidate.available && variantMatchesSelectedOptions(candidate, selectedOptions, index);
            });

            if (availableForSelection) {
              selectedOptions[index] = optionValue;
              break;
            }
          }
        });

        return selectedOptions;
      };

      const renderOptionSelects = (item, selectedOptions) => {
        const container = item.querySelector('[data-look-set-options]');
        if (!container) return;

        const variants = parseJsonAttr(item, 'data-product-variants', []);
        const options = parseJsonAttr(item, 'data-product-options', []);
        const indexes = parseJsonAttr(item, 'data-hover-option-indexes', [])
          .map(index => Number.parseInt(index, 10))
          .filter(index => Number.isFinite(index) && index >= 0);

        if (!indexes.length || !variants.length) {
          container.innerHTML = '';
          return;
        }

        const normalizedOptions = ensureSelectedOptions(item, [...selectedOptions]);
        item.setAttribute('data-selected-options', JSON.stringify(normalizedOptions));

        const productId = item.getAttribute('data-product-id') || '0';
        const rows = indexes.map(index => {
          const optionName = options[index] || '';
          const seen = new Set();
          const optionElements = [];

          for (const variant of variants) {
            const optionValue = variantOptions(variant)[index];
            if (!optionValue || seen.has(optionValue)) continue;
            seen.add(optionValue);

            const valueVariants = variants.filter(candidate => variantOptions(candidate)[index] === optionValue);
            const availableForSelection = valueVariants.some(candidate => {
              return candidate.available && variantMatchesSelectedOptions(candidate, normalizedOptions, index);
            });
            const isSelected = normalizedOptions[index] === optionValue;
            const displayText = displayOptionText(optionValue, optionName);
            const disabledAttr = availableForSelection ? '' : ' disabled';

            optionElements.push(
              `<option value="${escapeHtml(optionValue)}"${isSelected ? ' selected' : ''}${disabledAttr}>${escapeHtml(displayText)}</option>`
            );
          }

          return `
            <div class="look-set-drawer__size-row" data-look-set-option-row data-option-index="${index}">
              <label class="visually-hidden" for="LookSetSize-${escapeHtml(productId)}-${index}">${escapeHtml(optionName)}</label>
              <select
                id="LookSetSize-${escapeHtml(productId)}-${index}"
                class="look-set-drawer__size-select"
                data-look-set-option-select
                data-option-index="${index}">
                ${optionElements.join('')}
              </select>
            </div>
          `;
        });

        container.innerHTML = rows.join('');
      };

      const updateItemPrice = (item, variant, productData) => {
        const priceEl = item.querySelector('[data-look-set-price-current]');
        if (!priceEl) return;

        const price = variant?.price ?? productData?.price ?? Number.parseInt(item.getAttribute('data-product-price') || '0', 10);
        const comparePrice = variant?.compare_at_price ?? productData?.comparePrice ?? Number.parseInt(item.getAttribute('data-product-compare-price') || '0', 10);
        const priceVaries = productData?.priceVaries || item.getAttribute('data-product-price-varies') === 'true';

        let html = priceVaries && theme.strings?.productFrom
          ? `${theme.strings.productFrom}${formatMoney(price)}`
          : formatMoney(price);

        const priceWrap = item.querySelector('[data-look-set-price]');
        if (priceWrap) {
          priceWrap.querySelector('.grid-product__price--original')?.remove();
          if (comparePrice > price) {
            priceWrap.insertAdjacentHTML('beforeend', `
              <span class="visually-hidden">${theme.strings?.regularPrice || 'Regular price'}</span>
              <span class="grid-product__price--original">${formatMoney(comparePrice)}</span>
            `);
          }
        }

        priceEl.innerHTML = html;
      };

      const updateSizeGuideDrawerId = (item) => {
        if (!item || !this.sectionId) return;

        const productId = item.getAttribute('data-product-id');
        if (!productId) {
          item.removeAttribute('data-size-guide-drawer-id');
          return;
        }

        const drawerId = `SizeGuideDrawer-${this.sectionId}-${productId}`;
        if (document.getElementById(drawerId)) {
          item.setAttribute('data-size-guide-drawer-id', drawerId);
        } else {
          item.removeAttribute('data-size-guide-drawer-id');
        }
      };

      const syncItemFromProductData = (item, productData) => {
        if (!item || !productData) return;

        item.setAttribute('data-product-id', productData.id || '');
        item.setAttribute('data-product-title', productData.title || '');
        item.setAttribute('data-product-style-title', productData.styleTitle || splitStyleTitle(productData.title || ''));
        item.setAttribute('data-product-price', String(productData.price || 0));
        item.setAttribute('data-product-compare-price', String(productData.comparePrice || 0));
        item.setAttribute('data-product-price-varies', String(!!productData.priceVaries));
        item.setAttribute('data-product-options', JSON.stringify(productData.options || []));
        item.setAttribute('data-product-variants', JSON.stringify(productData.variants || []));
        item.setAttribute('data-hover-option-indexes', JSON.stringify(productData.hoverOptionIndexes || []));

        if (productData.promoCode) {
          item.setAttribute('data-promo-code', productData.promoCode);
        } else {
          item.removeAttribute('data-promo-code');
        }

        if (productData.fabricLabel) {
          item.setAttribute('data-fabric-label', productData.fabricLabel);
        } else {
          item.removeAttribute('data-fabric-label');
        }

        updateSizeGuideDrawerId(item);

        if (productData.url) {
          updateItemProductLinks(item, productData.url);
        }

        const titleEl = item.querySelector('[data-look-set-title]');
        if (titleEl) titleEl.textContent = productData.styleTitle || splitStyleTitle(productData.title || '');

        const colorLabel = splitStyleLabel(productData.title || '');
        item.setAttribute('data-selected-label', colorLabel);
        updateItemVariantLabel(
          item,
          productData.fabricLabel || item.getAttribute('data-fabric-label') || '',
          colorLabel
        );

        if (productData.imageFirst) {
          setItemImage(item, productData.imageFirst, productData.title || '');
        }

        const variants = Array.isArray(productData.variants) ? productData.variants : [];
        const preferredVariant = variants.find(variant => variant.available) || variants[0] || null;
        const selectedOptions = preferredVariant ? variantOptions(preferredVariant) : [];
        item.setAttribute('data-selected-options', JSON.stringify(selectedOptions));
        item.setAttribute('data-selected-variant-id', preferredVariant?.id ? String(preferredVariant.id) : '');

        updateItemPromo(
          item,
          computeDiscountBadge(preferredVariant?.price, preferredVariant?.compare_at_price),
          productData.promoCode || item.getAttribute('data-promo-code') || ''
        );

        renderOptionSelects(item, selectedOptions);
        updateItemPrice(item, preferredVariant, productData);
        updateItemAvailability(item, preferredVariant);
      };

      const updateItemAvailability = (item, variant) => {
        const stockEl = item.querySelector('[data-look-set-stock]');
        const available = !!variant?.available;
        item.classList.toggle('look-set-drawer__item--sold-out', !available);

        if (stockEl) {
          stockEl.textContent = available ? '' : strings.soldOut;
          stockEl.hidden = available;
        }
      };

      const resolveItemVariant = (item) => {
        const selectedOptions = parseJsonAttr(item, 'data-selected-options', []);
        const variant = findVariantForSelectedOptions(item, selectedOptions);
        item.setAttribute('data-selected-variant-id', variant?.id ? String(variant.id) : '');
        updateItemPrice(item, variant);
        updateItemPromo(
          item,
          computeDiscountBadge(variant?.price, variant?.compare_at_price),
          item.getAttribute('data-promo-code') || ''
        );
        updateItemAvailability(item, variant);
        return variant;
      };

      const getDrawerItems = (drawerRoot) => {
        return Array.from(drawerRoot.querySelectorAll('[data-look-set-item]'));
      };

      const drawerCanSubmit = (drawerRoot) => {
        const items = getDrawerItems(drawerRoot);
        if (!items.length) return false;
        return items.every(item => {
          const variantId = item.getAttribute('data-selected-variant-id');
          const variant = findVariantForSelectedOptions(item, parseJsonAttr(item, 'data-selected-options', []));
          return variantId && variant?.available;
        });
      };

      const updateDrawerTotal = (drawerRoot) => {
        const submit = drawerRoot.querySelector('[data-look-set-submit]');
        if (!submit) return;

        const baseLabel = drawerRoot.getAttribute('data-submit-label') || submit.textContent.trim();
        let total = 0;

        getDrawerItems(drawerRoot).forEach(item => {
          const variant = findVariantForSelectedOptions(item, parseJsonAttr(item, 'data-selected-options', []));
          if (!variant?.available) return;
          total += (variant.price || 0) * getItemQuantity(item);
        });

        submit.textContent = total > 0 ? `${baseLabel} ${formatMoney(total)}` : baseLabel;
        submit.disabled = !drawerCanSubmit(drawerRoot);
        submit.classList.toggle('kit-button--disabled', submit.disabled);
      };

      const setDrawerError = (drawerRoot, message) => {
        const error = drawerRoot.querySelector('[data-look-set-error]');
        if (!error) return;
        error.textContent = message || '';
        error.hidden = !message;
      };

      const initDrawerQtySelectors = (drawerRoot) => {
        if (!window.theme?.QtySelector) return;
        drawerRoot.querySelectorAll('.js-qty__wrapper').forEach(wrapper => {
          if (wrapper.dataset.lookSetQtyBound === 'true') return;
          wrapper.dataset.lookSetQtyBound = 'true';
          new theme.QtySelector(wrapper);
        });
      };

      const onDrawerOpen = (overlayDrawer) => {
        const drawerRoot = overlayDrawer.querySelector('[data-look-set-drawer]');
        if (!drawerRoot) return;

        setDrawerError(drawerRoot, '');
        initDrawerQtySelectors(drawerRoot);

        getDrawerItems(drawerRoot).forEach(item => {
          resolveItemVariant(item);
          updateItemImageNav(item);
        });

        if (typeof window.initSwatches === 'function') {
          window.initSwatches();
        }

        updateDrawerTotal(drawerRoot);
      };

      this.querySelectorAll('overlay-drawer').forEach(overlayDrawer => {
        if (overlayDrawer.dataset.lookSetObserverBound === 'true') return;
        if (!overlayDrawer.querySelector('[data-look-set-drawer]')) return;

        overlayDrawer.dataset.lookSetObserverBound = 'true';

        const observer = new MutationObserver(() => {
          if (overlayDrawer.getAttribute('open') === 'true') {
            onDrawerOpen(overlayDrawer);
          }
        });

        observer.observe(overlayDrawer, { attributes: true, attributeFilter: ['open'] });
      });

      if (this._lookSetEventsBound) return;
      this._lookSetEventsBound = true;

      document.addEventListener('click', (event) => {
        const drawerRoot = event.target.closest('[data-look-set-drawer]');
        if (!drawerRoot || drawerRoot.getAttribute('data-look-set-section-id') !== this.sectionId) return;

        const removeTrigger = event.target.closest('[data-look-set-remove]');
        if (removeTrigger) {
          event.preventDefault();
          const item = removeTrigger.closest('[data-look-set-item]');
          if (!item) return;

          if (getDrawerItems(drawerRoot).length <= 1) {
            setDrawerError(drawerRoot, strings.minItems);
            return;
          }

          item.remove();
          setDrawerError(drawerRoot, '');
          updateDrawerTotal(drawerRoot);
          return;
        }

        const swatchAnchor = event.target.closest('.look-set-drawer .productCard-swatches .productSwatch a[data-related-product-id]');
        if (swatchAnchor) {
          event.preventDefault();
          const item = swatchAnchor.closest('[data-look-set-item]');
          const productData = parseSwatchProductData(swatchAnchor);
          if (!item || !productData) return;

          swatchAnchor.closest('.productCard-swatches')?.querySelectorAll('.productSwatch a').forEach(anchor => {
            anchor.classList.remove('active');
            anchor.closest('.productSwatch')?.classList.remove('active');
          });
          swatchAnchor.classList.add('active');
          swatchAnchor.closest('.productSwatch')?.classList.add('active');

          syncItemFromProductData(item, productData);
          setDrawerError(drawerRoot, '');
          updateDrawerTotal(drawerRoot);
          return;
        }

        if (event.target.closest('[data-look-set-image-prev]')) {
          event.preventDefault();
          shiftItemImage(event.target.closest('[data-look-set-item]'), -1);
          return;
        }

        if (event.target.closest('[data-look-set-image-next]')) {
          event.preventDefault();
          shiftItemImage(event.target.closest('[data-look-set-item]'), 1);
          return;
        }

        const submit = event.target.closest('[data-look-set-submit]');
        if (submit) {
          event.preventDefault();
          if (submit.disabled || submit.classList.contains('kit-button--loading')) return;

          if (!drawerCanSubmit(drawerRoot)) {
            setDrawerError(drawerRoot, strings.errorIncomplete);
            return;
          }

          const items = getDrawerItems(drawerRoot).map(item => ({
            id: Number.parseInt(item.getAttribute('data-selected-variant-id') || '', 10),
            quantity: getItemQuantity(item)
          })).filter(line => Number.isFinite(line.id) && line.id > 0);

          if (!items.length) {
            setDrawerError(drawerRoot, strings.errorIncomplete);
            return;
          }

          submit.classList.add('kit-button--loading');
          submit.disabled = true;

          fetch(theme.routes.cartAdd, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ items })
          })
            .then(response => response.json())
            .then(data => {
              if (data.status === 422) {
                throw data;
              }

              const overlayDrawer = drawerRoot.closest('overlay-drawer');
              overlayDrawer?.close?.();

              document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                detail: {
                  product: data,
                  addToCartBtn: submit
                }
              }));
            })
            .catch(errorData => {
              const message = errorData && (errorData.description || errorData.message)
                ? errorData.description || errorData.message
                : strings.errorAddFailed;
              setDrawerError(drawerRoot, message);
            })
            .finally(() => {
              submit.classList.remove('kit-button--loading');
              updateDrawerTotal(drawerRoot);
            });
        }
      }, { signal });

      document.addEventListener('change', (event) => {
        const optionSelect = event.target.closest('[data-look-set-option-select]');
        if (optionSelect) {
          const drawerRoot = optionSelect.closest('[data-look-set-drawer]');
          if (!drawerRoot || drawerRoot.getAttribute('data-look-set-section-id') !== this.sectionId) return;

          const item = optionSelect.closest('[data-look-set-item]');
          const optionIndex = Number.parseInt(optionSelect.getAttribute('data-option-index') || '-1', 10);
          const optionValue = optionSelect.value || '';
          if (!item || !Number.isFinite(optionIndex) || optionIndex < 0 || !optionValue) return;

          const selectedOptions = parseJsonAttr(item, 'data-selected-options', []);
          selectedOptions[optionIndex] = optionValue;
          item.setAttribute('data-selected-options', JSON.stringify(selectedOptions));
          renderOptionSelects(item, selectedOptions);
          resolveItemVariant(item);
          setDrawerError(drawerRoot, '');
          updateDrawerTotal(drawerRoot);
          return;
        }

        if (!event.target.matches('.look-set-drawer .js-qty__num')) return;
        const drawerRoot = event.target.closest('[data-look-set-drawer]');
        if (!drawerRoot || drawerRoot.getAttribute('data-look-set-section-id') !== this.sectionId) return;
        updateDrawerTotal(drawerRoot);
      }, { signal });

      document.addEventListener('click', (event) => {
        if (!event.target.closest('.look-set-drawer .js-qty__adjust')) return;
        const drawerRoot = event.target.closest('[data-look-set-drawer]');
        if (!drawerRoot || drawerRoot.getAttribute('data-look-set-section-id') !== this.sectionId) return;
        window.requestAnimationFrame(() => updateDrawerTotal(drawerRoot));
      }, { signal });
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.look-card-carousel__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.lookCardCarouselBound === 'true') return;
        link.dataset.lookCardCarouselBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.look-card-carousel__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.lookCardCarouselPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.lookCardCarouselPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-look-card-carousel', KitLookCardCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook-products"] && !Shopify.designMode) return;
  try {
    
  /*
   * Self-contained entrance for the rows.
   *
   * The theme has its own scroll-reveal engine, but it is behind a store-wide
   * switch (Theme settings > Scroll animations). When that switch is on, this
   * defers to it completely so a card is never animated twice; when it is off,
   * the section still animates, because the rows are meant to arrive as you
   * come down the page.
   */
  class LookbookRows extends HTMLElement {
    connectedCallback() {
      if (this.dataset.reveal === 'off') return;

      const html = document.documentElement;
      const themeEngineRunning = html.classList.contains('scroll-reveal');
      const animationsOff = document.body.getAttribute('data-disable-animations') === 'true';
      const reducedMotion = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (themeEngineRunning || animationsOff || reducedMotion || !('IntersectionObserver' in window)) return;

      const items = Array.from(this.querySelectorAll('[data-reveal-item]'));
      if (!items.length) return;

      this.stagger = parseInt(this.style.getPropertyValue('--lbr-stagger'), 10) || 90;
      this.pending = new Set();

      // Section scripts are bundled and deferred, and on a page carrying this
      // many third-party tags that bundle can land well after first paint. Only
      // cards still below the fold are hidden, so a card the shopper is already
      // looking at is never blinked out and replayed.
      items.forEach((item) => {
        if (item.getBoundingClientRect().top >= window.innerHeight) {
          item.classList.add('lbr-hidden');
          this.pending.add(item);
        }
      });

      if (!this.pending.size) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          // Entries arrive in document order within a callback, so staggering by
          // position in the batch makes a row read left to right.
          let step = 0;

          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            this.reveal(entry.target, step);
            step += 1;
          });

          this.sweep(step, 1);
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
      );

      this.pending.forEach((item) => this.observer.observe(item));

      // Rows re-flow as the card images settle, and a fast scroll or a restored
      // scroll position can carry a card past the viewport between observer
      // ticks. A card that never reveals is an invisible product, so both cases
      // get a safety net. The scroll sweep uses a later threshold than the
      // observer so it only catches what the observer missed, leaving the
      // stagger to the observer in ordinary scrolling.
      this.onLoad = () => this.sweep(0, 1);
      this.onScroll = () => this.sweep(0, 0.5);

      window.addEventListener('load', this.onLoad, { once: true });
      window.addEventListener('scroll', this.onScroll, { passive: true });

      // The theme editor re-renders blocks in place; anything added after the
      // first pass would otherwise stay at zero opacity forever.
      if (window.Shopify && Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          const item = event.target.closest('[data-reveal-item]');
          if (item) item.classList.remove('lbr-hidden');
        });
      }
    }

    reveal(item, step) {
      item.style.setProperty('--lbr-delay', step * this.stagger + 'ms');
      item.classList.remove('lbr-hidden');
      this.observer.unobserve(item);
      this.pending.delete(item);

      if (!this.pending.size) this.teardown();
    }

    // Anything the viewport has already reached is revealed outright, whatever
    // the observer saw. `ratio` is where in the viewport the cut-off sits.
    sweep(startStep, ratio) {
      if (!this.pending.size) return;

      const cutoff = window.innerHeight * ratio;
      let step = startStep || 0;

      Array.from(this.pending).forEach((item) => {
        if (item.getBoundingClientRect().top < cutoff) {
          this.reveal(item, step);
          step += 1;
        }
      });
    }

    teardown() {
      if (this.observer) this.observer.disconnect();
      if (this.onLoad) window.removeEventListener('load', this.onLoad);
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
    }

    disconnectedCallback() {
      this.teardown();
    }
  }

  if (!customElements.get('lookbook-rows')) {
    customElements.define('lookbook-rows', LookbookRows);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  // <product-form> (snippets/form.product.liquid) reports success on its own event and
  // never fires ajaxProduct:added, so this page has to relay it for the theme code that
  // listens for the older event: the cart drawer and the shipping-insurance re-tier.
  //
  // The detail is not optional. Both of those read `detail.product` as the success test —
  // theme.AjaxProduct fires ajaxProduct:added with no detail on its 422 branch, so a bare
  // relay reads as a *failed* add and is discarded. That left the drawer on this template
  // opening only as a side effect of the add-on popup, and the insurance tier never
  // recalculating at all.
  document.addEventListener('product-form:submit:success', (event) => {
    const detail = event.detail || {};

    document.dispatchEvent(
      new CustomEvent('ajaxProduct:added', {
        detail: {
          // The /cart/add.js body, under the key theme.AjaxProduct.success uses for it.
          // `|| {}` guards the subscriber-supplied path in waitForCartResponse(): the add
          // did succeed, so listeners must act even if that response came back empty.
          product: detail.response || {},
          // assets/upsell-popup.js listens for product-form:submit:success itself, so
          // without this it answers the same add twice — two resolves racing to open one
          // popup.
          suppressUpsell: true
        }
      })
    );
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
